import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import CoreTextarea from '@sparefoot/react-core/Textarea';
import { Label } from 'components/core/Label';
import { Paragraph } from 'components/core/Typography';

import './Textarea.scss';

let textareaId = 0;

export default function Textarea({
	id,
	name,
	label,
	value,
	error,
	helpText,
	onBlur,
	onFocus,
	onChange,
}) {
	textareaId += 1;
	const resolvedId = id ?? `ss-textarea-${textareaId}`;
	return (
		<Label
			text={label}
			htmlFor={resolvedId}
			helpText={helpText}
			className={classnames('ss-textarea-label', { error })}
			render={(renderProps) => (
				<CoreTextarea
					id={renderProps.id}
					name={name}
					value={value}
					onBlur={onBlur}
					onFocus={onFocus}
					onChange={onChange}
					className="ss-textarea"
				/>
			)}
		>
			{!!helpText && (
				<Paragraph className="help-text">{helpText}</Paragraph>
			)}
			{!!error && (
				<Paragraph className="error-message">{error}</Paragraph>
			)}
		</Label>
	);
}

Textarea.propTypes = {
	id: PropTypes.string,
	name: PropTypes.string,
	label: PropTypes.string,
	value: PropTypes.string,
	error: PropTypes.string,
	helpText: PropTypes.string,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func,
	onChange: PropTypes.func,
};
